import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { ApiService } from '../api/api.service';
import { EmailSuggestionsModel, HomeModel } from './home.models';

@Injectable({ providedIn: 'root' })
export class HomeResourceService {
    constructor(private api: ApiService) {}

    getInitValues(): Observable<HomeModel> {
        return this.api.get('home/GetInitData');
    }

    getInitDataForEmailSuggestions(): Observable<EmailSuggestionsModel> {
        return this.api.get('home/GetInitDataForEmailSuggestions');
    }
}
